export function distinctStrings(arr: string[]) {
  return Array.from(new Set(arr));
}

export function distinctNumbers(arr: number[]) {
  return Array.from(new Set(arr));
}

export function distinctBy<T, K>(arr: T[], keySelector: (item: T) => K): T[] {
  const seen = new Set<K>();
  return arr.filter((item) => {
    const key = keySelector(item);
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
}
